// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const providerProductAreaSchema = z.object({
  "area": z.enum(["passwordless", "application_sign_in", "identity_governance", "private_access", "privileged_access", "badge_sign_in", "kiosk_pass", "non_human_identity", "windows_sign_in", "compliance", "directory"]),
  "entitlement": z.object({
    "status": z.enum(["contracted", "not_contracted", "suspended"]),
    "source": z.string().min(1),
    "effective_from": z.string().datetime({ offset: true }).optional(),
    "effective_until": z.string().datetime({ offset: true }).optional(),
    "version": z.number().int().min(1),
    "changed_by": z.string().optional(),
    "changed_at": z.string().datetime({ offset: true })
  }).strict().nullable()
}).strict();

export const productAreaCensusSchema = z.object({
  "data": z.array(providerProductAreaSchema)
}).strict();

export const tenantListItemSchema = z.object({
  "id": z.string().uuid(),
  "name": z.string(),
  "slug": z.string(),
  "status": z.enum(["active", "suspended", "deactivated", "deleted"]),
  "is_infrastructure": z.boolean(),
  "tenant_type": z.enum(["workforce", "customer"]),
  "customer_audience": z.enum(["organization_members", "individual_customers", "mixed", "unspecified"]),
  "created_at": z.string().datetime({ offset: true }),
  "updated_at": z.string().datetime({ offset: true })
});

export const tenantsListResponseSchema = z.object({
  "items": z.array(tenantListItemSchema),
  "next_cursor": z.string().optional(),
  "total": z.number().int()
});
